<template>
    <div class="vx-col w-3/12">
      <vx-card class="shadow">
        <div class="flex w-full mb-8 justify-between">
          <div class="w-6/12">
            <vs-icon icon-pack="material-icons" icon="filter_list" />
            <span class="font-bold ml-2">FILTROS</span>
          </div>
          <vs-icon icon-pack="material-icons" icon="delete_forever" style="font-size: 24px; position: relative; top: -4px" class="text-danger cursor-pointer" @click="clearFields()" />
        </div>

        <div class="w-full mb-4">
          <span>A partir de</span>
          <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="dateFilterFrom"></datepicker>
        </div>

        <div class="w-full mb-4">
          <span>Até o dia</span>
          <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="dateFilterTo" ></datepicker>
        </div>

        <div class="w-full">
          <vs-button color="danger" type="relief" class="w-full" @click="getRatings()"> Filtrar período </vs-button>
        </div>

        <vs-divider />

        <div class="w-full mb-4">
          <span>Estrelas</span>
          <star-rating :show-rating="false" active-color="#EA5455" inactive-color="#f6dadb" v-model="stars" :star-size="46"></star-rating>
          <transition name="slide-fade" mode="out-in">
            <span key="ratings" class="text-danger cursor-pointer" v-show="_filter.stars" @click="resetStars"> Remover estrelas </span>
          </transition>
        </div>

        <vs-divider />

        <div class="w-full mb-4">
          <vs-checkbox class="w-full mb-4" v-model="filterWithOpionOnly" > Apenas com opinião </vs-checkbox>
        </div>

        <vs-divider />

        <div class="w-full mb-4">
          <span class="w-full"> Por tag </span>
          <v-select multiple :closeOnSelect="false" v-model="selectedTagFilter" :options="optionsTag" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>

        <div class="w-full mt-10">
          <span class="text-grey" v-if="!ratings.length">Nenhum registro encontrado</span>
          <span class="text-grey" v-else> {{ filteredRatings.length }} registros encontrados </span>
        </div>
        
      </vx-card>
    </div>
</template>

<script>
  import StarRating from 'vue-star-rating'
  import Datepicker from 'vuejs-datepicker'
  import * as lang from 'vuejs-datepicker/src/locale'
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
  import _misc from '@/assets/utils/misc.js'
  import vSelect from 'vue-select'
  import { comments } from './Ratings.js'

  const DATE_LIMIT = 30 // days
  
  export default {
    components : {
      vSelect,
      StarRating,
      Datepicker
    },

    data () {
      return {
        optionsTag : [],
        languages: lang,
        highlightedFn : {
            customPredictor(date) {
                let today = new Date()
                if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
                    return true;
                }
            }
        },
      }
    },

    mounted () {
      this.optionsTag = comments
      .filter(rating => typeof(rating.id) === 'string')
      .map(rating => Object({label : rating.text, value : rating.id}))
    },

    computed : {
        selectedTagFilter : {
          get () {
            return this._filter.selectedTags
          },
          set (val) {
            this.setSelectedTags(val)
          }
        },

        filterWithOpionOnly : {
          get () {
            return this._filter.opionOnly
          },
          set (val) {
            this.setOpionOnlyFilter(val)
          }
        },

        dateFilterFrom : {
          get () {
            return this._filter.date.from
          },
          set (val) {
            this.setDateFrom(val)
          }
        },

        dateFilterTo : {
          get () {
            return this._filter.date.to
          },
          set (val) {
            this.setDateTo(val)
          }
        },

        stars : {
          get () {
            return this._filter.stars
          },
          set (val) {
            this.setStars(val)
          }
        }, 

        ...mapGetters('ratings', ['filteredRatings']),
        ...mapState('ratings', ['_filter', 'ratings'])
    },

    methods : {
      async getRatings () {
        try {
          const diferenceBetweenDate = _misc.diferenceBetweenDates(this.dateFilterTo, this.dateFilterFrom)
          if(diferenceBetweenDate.days > DATE_LIMIT) 
            throw new Error(`O limite do período entre as datas é de ${DATE_LIMIT} dias.`)

          this.$vs.loading()
          await this.fetchRatings(10)
        } catch (err) {
          this.$error({
            zIndex: 999999,
            content: err.message,
            title : 'Erro!' 
          })
        } finally {
          this.$vs.loading.close()
        }
      },
      
      ...mapActions('ratings', ['fetchRatings']),
      ...mapMutations('ratings', ['setDateFrom', 'setDateTo', 'setStars', 'resetStars', 'clearFields', 'setOpionOnlyFilter', 'setSelectedTags'])
    }
  }
</script>

<style>
  .slide-fade-enter-active {
      transition: all .2s ease;
  }
  .slide-fade-leave-active {
      transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active for <2.1.8 */ {
      transform: translateX(10px);
      opacity: 0;
  }
</style>